import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=0ad5f60c&"
import script from "./RedirectPage.vue?vue&type=script&lang=ts&"
export * from "./RedirectPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports